import { DEFAULT_REGION_CODE, REGIONS_DATA } from '@/data'

/**
 * Creates a GROQ query string for language-specific content with fallback
 *
 * @param fieldsArray - Array of field definitions to include in the query
 * @returns GROQ query string
 */
export const getLanguageQueryString = (
  fieldsArray: (
    | string
    | {
        name: string
        fields: string
        dereference?: boolean
        isArray?: boolean
      }
  )[],
) => {
  let defaultQueryString = ''
  let localizedQueryString = ''

  fieldsArray.forEach(item => {
    if (typeof item === 'string') {
      defaultQueryString += `${item},`
      localizedQueryString += `defined(${item}) => {"${item}": ${item}},`
    } else if (typeof item === 'object' && item !== null) {
      const arrString = item.isArray ? '[]' : ''
      defaultQueryString += `${
        item?.dereference ? `${item.name} ${arrString}->` : `${item.name}${arrString}`
      } {${item.fields}},`
      localizedQueryString += `
      defined(${item.name}) => {
        ${item?.dereference ? `'${item.name}': ${item.name} ${arrString}->` : `'${item.name}${arrString}': ${item.name}`} {
          ${item.fields}
        }
      },
      `
    }
  })

  return `
    ...select(
      $language != "${DEFAULT_REGION_CODE}" => {
        ...i18n.${DEFAULT_REGION_CODE} { ${defaultQueryString} },
        defined(i18n[$language]) => {
          ...i18n[$language] { ${localizedQueryString} }
        }
      },
      $language == "${DEFAULT_REGION_CODE}" => {
        ...i18n.${DEFAULT_REGION_CODE} { ${defaultQueryString} }
      },
      null
    )
  `
}

/**
 * Generates GROQ query for region-specific data overrides
 */
export const getMainDataOverrides = ({
  mainDataOverrides,
  mainObjectName,
}: {
  objectSuffix: string
  mainObjectName: string
  mainDataOverrides: string[]
}) => {
  let query = ''
  if (mainObjectName && mainDataOverrides?.length) {
    query = `
     ${Object.values(REGIONS_DATA)
       .map(({ code: regionCode }) => {
         if (regionCode === DEFAULT_REGION_CODE) return ''
         return `
        ${mainDataOverrides
          .map(overrideString => {
            const objectPath = `${mainObjectName}.i18n.${regionCode}.${overrideString}`
            return `
            $language == "${regionCode}" => {
              defined(${objectPath}) => {"${overrideString}": ${objectPath}}
            },
          `
          })
          .join('')}
      `
       })
       .join('')}
  `
  }

  return query
}
